import { useNectarProjects } from '@/features/nectar/api'
import { nectarProjectToMission } from '@/features/nectar/api/normalizer'
import { useMemo } from 'react'
import { useMissionsList } from './api'
import { useMissionsUrl } from './context/MissionsUrlProvider'
import { Missions } from './Missions'

export const MissionsForAuthorizedUser = () => {
  const { missionsUrl, platform } = useMissionsUrl()
  const { data: missionsList, isFetching: isFetchingMissions } = useMissionsList({ platform })
  const { data: nectarData, isFetching: isFetchingNectar } = useNectarProjects()

  const isInitialLoad = (isFetchingMissions && !missionsList) || (isFetchingNectar && !nectarData)

  const availableMissions = useMemo(() => {
    const missions = missionsList ?? []
    const nectarMissions = (nectarData?.data ?? []).map((project) => nectarProjectToMission(project, missionsUrl))
    return [...nectarMissions, ...missions].toSorted((a, b) => a.sortOrder - b.sortOrder)
  }, [missionsList, nectarData, missionsUrl])

  return <Missions availableMissions={availableMissions} isInitialLoad={isInitialLoad} />
}

export const MissionsForUnauthorizedUser = () => {
  const { platform } = useMissionsUrl()
  const { data: missionsList, isFetching: isFetchingMissions } = useMissionsList({
    platform,
    jwt: 'eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJhbGVuYUBkYXRhaGl2ZS5haSIsImV4cCI6MTgzOTMxNjkzMH0.k5-mSp0JFWDk4NcETVQszK2xqdHPnJ6siNevUjMU83E'
  })

  const isInitialLoad = isFetchingMissions && !missionsList

  const availableMissions = useMemo(() => {
    return [...(missionsList ?? [])].toSorted((a, b) => a.sortOrder - b.sortOrder)
  }, [missionsList])

  return <Missions availableMissions={availableMissions} isInitialLoad={isInitialLoad} />
}
